import { can, CAPABILITY } from '@/actions/permissions';

// Rendering and event handlers use the same reactive account policy as Vuex actions.
export default {
  computed: {
    canViewAiAnalysis() { return can(CAPABILITY.AI_ANALYSIS_VIEW, this.$store); },
    canRunAiAnalysis() { return can(CAPABILITY.AI_ANALYSIS_RUN, this.$store); },
    canReviewAiAnalysis() { return can(CAPABILITY.AI_ANALYSIS_REVIEW, this.$store); },
  },
};
